import { CheckCircleOutlined } from '@ant-design/icons';
import { httpCreators } from 'rbh-merchant-core';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RBHBox, RBHImage, RBHText } from '../../../../shared/components';
import { Images } from '../../../../shared/theme';
import { EMAIL_VERIFICATION_STATUS, REPORT_REQUEST_ID_LIST } from '../redux/report-constant';
import { REPORT_STATE_KEY, reportStateSelector } from '../redux/report-reducer';
import { reportSagas } from '../redux/report-saga';
import { ReportService } from '../redux/report-service';
import styles from './style';

export const ConfirmEmailScreen: React.FC<{}> = () => {
  const dispatch = useDispatch();
  const state = useSelector(reportStateSelector(REPORT_STATE_KEY.VERIFY_STATUS));

  const verifyEmail = async (verificationCode: string) => {
    dispatch(httpCreators.request({
      service: ReportService.verifyEmail,
      serviceParams: verificationCode,
      id: REPORT_REQUEST_ID_LIST.VERIFY_EMAIL,
      sagaHandler: reportSagas.verifyEmailHandler
    }));
  };

  useEffect(() => {
    const pathname = window.location.pathname;
    const verificationCode = pathname.split('/confirm-email/')[1];
    verifyEmail(verificationCode);
  }, []);

  const renderStatus = () => {
    switch (state) {
      case EMAIL_VERIFICATION_STATUS.SUCCESS:
        return (<RBHBox style={styles.container}>
          <CheckCircleOutlined data-testid={'status-image'} id={'status-image'} translate={null} style={styles.successIconImage} />
          <RBHText data-testid={'title'} id={'title'} style={styles.title} text={'main.confirmEmail.success.title'} />
          <RBHText data-testid={'description'} id={'description'} style={styles.description} text={'main.confirmEmail.success.desc'} />
        </RBHBox>);
      case EMAIL_VERIFICATION_STATUS.EXPIRED:
        return (<RBHBox style={styles.container}>
          <RBHImage data-testid={'status-image'} id={'status-image'} style={styles.image} src={Images.chef} />
          <RBHText data-testid={'title'} id={'title'} style={styles.title} text={'main.confirmEmail.expired.title'} />
          <RBHText data-testid={'description'} id={'description'} style={styles.description} text={'main.confirmEmail.expired.desc'} />
        </RBHBox>);
      case EMAIL_VERIFICATION_STATUS.ALREADY_VERIFIED:
        return (<RBHBox style={styles.container}>
          <RBHImage data-testid={'status-image'} id={'status-image'} style={styles.image} src={Images.chef} />
          <RBHText data-testid={'title'} id={'title'} style={styles.title} text={'main.confirmEmail.alreadyVerified.title'} />
          <RBHText data-testid={'description'} id={'description'} style={styles.description} text={'main.confirmEmail.alreadyVerified.desc'} />
        </RBHBox>);
      default:
        return (<RBHBox style={styles.container}>
          <RBHImage data-testid={'status-image'} id={'status-image'} style={styles.image} src={Images.chef} />
          <RBHText data-testid={'title'} id={'title'} style={styles.title} text={'main.confirmEmail.error.title'} />
          <RBHText data-testid={'description'} id={'description'} style={styles.description} text={'main.confirmEmail.error.desc'} />
        </RBHBox>);
    }
  };

  return (
    <RBHBox style={styles.background}>
      {state ? renderStatus() : null}
    </RBHBox>
  );
};
